import React from 'react';
import ModalHeader from './ModalHeader';
import Modal from 'react-modal';

export default function ConfirmationModal({
  title,
  content,
  closeModal,
  modalAction,
  openModal,
}) {
  return (
    <Modal
      isOpen={openModal}
      onRequestClose={closeModal}
      portalClassName="confirmationModal"
      ariaHideApp={false}
    >
      <div>
        <ModalHeader title={title} CloseModal={closeModal} />
        <p className="text-sm">{content}</p>
        <div className="flex flex justify-end mt-6">
          <button
            className="border border-color-primary text-color-primary rounded-md py-2 text-sm px-6 ml-4"
            onClick={closeModal}
          >
            انصراف
          </button>
          <button
            className="bg-color-primary text-white rounded-md py-2 px-6 text-sm"
            onClick={modalAction}
          >
            بله
          </button>
        </div>
      </div>
    </Modal>
  );
}
